module.exports = __webpack_public_path__ + "static/media/ai-chatbot.7979b9b4.svg";